import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { toast } from 'react-toastify';

const URL = process.env.REACT_APP_API_ENDPOINT;

const EditTimingDialog = ({ item, onUpdate, isRekla }) => {
  console.log(isRekla, ': item rekal ');
  const token = localStorage.getItem('accessToken');
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    TimingSlabKey: item.TimingSlabKey || 0,
    TimingId: item.TimingId,
    TimeSlabName: item.name || item.TimingName || '',
    DisplayOrder: item.DisplayOrder || 0,
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleDialogClose = () => {
    // Reset form data to initial props
    setFormData({
      TimingSlabKey: item.TimingSlabKey || 0,
      TimingId: item.TimingId,
      TimeSlabName: item.name || item.TimingName || '',
      DisplayOrder: item.DisplayOrder || 0,
    });
    setOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // e.stopPropagation();
    setIsLoading(true);

    try {
      const response = await fetch(`${URL}Event/UpdateTimeSlab`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error('Failed to update timing data');

      const data = await response.json();
      if (data.Status === 0) {
        toast.warn('Please delete all existing timing info before updating the lap.');
        return;
      }
      const updatedItem = {
        ...item,
        name: formData.TimeSlabName,
        TimingName: formData.TimeSlabName,
        TimingSlabKey: formData.TimingSlabKey,
        DisplayOrder: formData.DisplayOrder,
      };

      onUpdate(updatedItem);
      setOpen(false);

      toast({
        title: 'Success',
        description: 'Timing data updated successfully',
      });
    } catch (error) {
      console.error(error);
      toast({
        title: 'Error',
        description: 'Failed to update timing data. Please try again.',
        variant: 'destructive',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        startIcon={<EditIcon fontSize="small" />}
        onClick={() => setOpen(true)}
      >
        Edit
      </Button>

      <Dialog open={open} onClose={handleDialogClose} fullWidth maxWidth="sm">
        <form onSubmit={handleSubmit}>
          <DialogTitle>Edit Timing Point</DialogTitle>
          <DialogContent dividers>
            <TextField
              fullWidth
              type="number"
              label="Timing Slab Key"
              disabled
              value={formData.TimingSlabKey}
              margin="normal"
            />
            <TextField
              fullWidth
              type="number"
              label="Display Order"
              disabled
              value={formData.DisplayOrder}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Timing ID"
              value={formData.TimingId}
              onChange={(e) => handleChange('TimingId', e.target.value)}
              margin="normal"
            />
            <TextField
              fullWidth
              required
              disabled={isRekla}
              label="Time Slab Name"
              value={formData.TimeSlabName}
              onChange={(e) => handleChange('TimeSlabName', e.target.value)}
              margin="normal"
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleDialogClose}
              disabled={isLoading}
              sx={{
                color: '#9f1d21',
                borderColor: '#9f1d21',
                '&:hover': {
                  borderColor: '#c03c78',
                  backgroundColor: '#ffe4f0',
                },
              }}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={isLoading}
              sx={{
                backgroundColor: '#9f1d21',
                '&:hover': {
                  backgroundColor: '#c03c78',
                },
              }}
            >
              {isLoading ? 'Updating...' : 'Update'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default EditTimingDialog;
